module.exports = __webpack_public_path__ + "img/UtilityTechBackgroundC08_ua.4623dcca.webp";